import React, { useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import theme from "../../styles/theme";

const sizes = { sm: "40%", lg: "80%", xl: "95%" };

const ModalBackDrop = styled(motion.div)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 70;
`;
const ModalContainer = styled(motion.div)<{ size: string }>`
    position: relative;
    max-height: 80%;
    width: ${({ size }) => (size ? sizes[size] : "30rem")};
    background: #fff;
    border-radius: 1rem;
    margin: auto;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    z-index: 2147483640;
    overflow-x: hidden;
    overflow-y: auto;
    color: ${theme.color.terciary.accent};

    @media (max-width: 980px) {
        width: 95%;
        max-height: 95%;
    }

    @media (max-width: 480px) {
        width: 95%;
        max-height: 95%;
    }
`;

const ModalContent = styled.div`
    margin: 2rem;

    .buttons {
        margin: 1rem 0;
        display: flex;

        button {
            &:last-child {
                margin-left: 1rem;
            }
        }
    }
`;

const TopBar = styled.div`
    height: 1.6rem;
    background: #fe8418;
    border-top-right-radius: 1rem;
    border-top-left-radius: 1rem;
`;

type ModalProps = {
    isOpen: boolean;
    onHide: () => void;
    blockModal?: boolean;
    size?: string;
    children: JSX.Element;
};

const Modal = ({ isOpen, onHide, size, children, blockModal }: ModalProps) => {
    const modal = useRef(null);

    const handleClose = (e) => {
        if (blockModal) {
            return;
        }
        if (modal.current && !modal.current.contains(e.target)) {
            onHide();
        }
    };

    return (
        <>
            {isOpen && (
                <>
                    <ModalBackDrop
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0, transition: { duration: 0.3 } }}
                        onClick={handleClose}
                    >
                        <ModalContainer
                            size={size}
                            initial={{ scale: 0 }}
                            animate={{ scale: 1, transition: { duration: 0.3 } }}
                            exit={{ scale: 0, transition: { duration: 0.3 } }}
                            ref={modal}
                        >
                            <TopBar />
                            <ModalContent>{children}</ModalContent>
                        </ModalContainer>
                    </ModalBackDrop>
                </>
            )}
        </>
    );
};

export default Modal;
